<template>
  <funding-project-base :state="state">
    <div class="container grid my-12">
      <section class="col-span-full">
        <forecast-summary-chart
          :forecast="forecast"
          :for-version="forecast.current.revision || 0"
          :intervention-rate="competition.max_partner_grant_intervention_rate || 100"
          embedded
        />
      </section>
      <claims-revision-list
        :funding="fundingPot"
        :project="project"
        :partners="partners"
        :claim-periods="claimPeriods"
        :forecast="forecast"
      />
    </div>
  </funding-project-base>
</template>

<script>
export default {
  name: "FundingProjectsFinanceIndex",
  computed: {
    fundingPot() {
      return this.state.funding_pot;
    },
    competition() {
      return this.state.competition;
    },
    project() {
      return this.state.project;
    },
    partners() {
      return this.state.partners;
    },
    forecast() {
      return this.state.forecast;
    },
    claimPeriods() {
      return this.state.claim_periods;
    },
  },
};
</script>

<style lang="styl" scoped>
::v-deep
  .grid
    display grid;
    grid-template-columns repeat(12, 1fr);
    grid-gap 1.5rem;

  .sub-grid
    display grid;
    grid-template-columns subgrid;

  .col
    for col in (1..12)
      &-span-{col}
        grid-column span col / span col;

    &-span-full
      grid-column 1 / -1;
</style>
